import { EquipmentItemOptionType } from '@/blocks/constructor/Equipments/components/EquipmentItem';
import { ICarOption, ICarOptionGroup } from '@/interfaces/cars.interfaces';
import sortCollectionItems from '@/utils/sortCollectionItems';

/**
 * Формирует данные для вкладки оборудования (основного или дополнительного).
 */
function formatEquipmentGroups(
  options: Array<ICarOption>,
): Array<EquipmentItemOptionType> {
  const groupMap = new Map<
    string,
    {
      group: ICarOptionGroup;
      options: Array<ICarOption>;
    }
  >();

  // Собираем опции в группы
  options.forEach(option => {
    const optionGroup = option.group;
    const group = groupMap.get(option.group.name);

    if (!optionGroup.id) {
      return;
    }

    if (!group) {
      groupMap.set(optionGroup.name, {
        group: optionGroup,
        options: [option],
      });

      return;
    }

    group.options.push(option);
  });

  // Сортируем группы в соответствии их позиции
  const groups = Array.from(groupMap.values());
  groups.sort((groupA, groupB) => sortCollectionItems(groupA.group, groupB.group));

  // Сортируем опции внутри группы
  groups.forEach(group => {
    group.options.sort(sortCollectionItems);
  });

  // Маппим данные группы в данные для отображения
  const displayGroups = groups.map(({ group, options }) => {
    return {
      id: group.id,
      title: group.displayName,
      items: options.map(({ id, displayName }) => ({
        key: id,
        label: displayName,
      })),
    };
  });

  return displayGroups;
}

export default formatEquipmentGroups;
